module.exports = __webpack_public_path__ + "static/media/Q5-7.63c47987.jpg";